// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3PqBq","right":"Footer_right__G1o55","buttons":"Footer_buttons__16DA5"};